import { axios } from 'shared/services/axios'
import { CAMPAIGN_ELEMENTS_TYPES } from 'shared/constants'

export function fetchOrganizationUsers(organizationId, params = {}) {
  return axios.post(
    `/api/v1/organizations/${organizationId}/users`, params)
    .then(response => response.data)
}

export function updateOrganizationUser(organizationId, userId, params = {}) {
  const userData = {
    ...params,
    name: params.first_name
  }

  return axios.put(
    `/api/v1/organizations/${organizationId}/users/${userId}`, userData)
    .then(response => response.data)
    .catch(error => {
      throw new Error(error.response?.data?.error ?? 'Server Error')
    })
}

export function fetchPrivacyMessages(organizationId, elementType = CAMPAIGN_ELEMENTS_TYPES.formPrivacyMessage) {
  return axios
    .get(`/api/organizations/${organizationId}/campaign_elements`, { params: { element_type: elementType } })
    .then(response => response.data)
}

export function fetchOrganizationAnalytics(organizationId) {
  return axios
    .get(`/api/v1/organizations/${organizationId}/user_management_summaries`)
    .then(response => response.data)
}

export function fetchOrganization(organizationId, domain = null) {
  return axios.get(`/api/organizations/${organizationId}`, {
    params: { domain }
  })
    .then(response => response.data)
}

export function fetchOrganizationDefaultAvgDealSize(organizationId) {
  return axios.get(`/api/organizations/${organizationId}/default_avg_deal_size`)
    .then(response => response.data)
}

export function updateOrganization(organizationId, params = {}) {
  return axios.put(`/api/organizations/${organizationId}`, params)
    .then(response => response.data)
}

export function fetchOrganizationLicense(organizationId) {
  return axios.get(`/api/v1/organizations/${organizationId}/license`)
    .then(response => response.data)
}

export function updateOrganizationLicense(organizationId, licenseData) {
  return axios.put(`/api/v1/organizations/${organizationId}/license`, licenseData)
    .then(response => response.data)
}

export function updateOrganizationPlan(organizationId, plan) {
  return axios.put(`/api/v1/organizations/${organizationId}/plan`, { plan_type: plan })
    .then(response => response.data)
}

export function fetchContentConsumption(organizationId) {
  return axios.get(`/api/v1/organizations/${organizationId}/content_consumption`)
    .then(response => response.data)
}
